import { plural } from '@frameio/i18n';
import { InputTokenStatus } from '../../utils';
import TEXT from './generated/TEXT/memberAccessFormConstants';

TEXT.DEFINE({
  /** Title for an existing group */
  existingGroupTitle: (label: string, memberCount: number) =>
    plural(memberCount, {
      one: `${label} contains 1 existing Member`,
      other: `${label} contains ${memberCount} existing Members`,
    }),
  /** Error message when adding group as a guest */
  existingGroupDetails: "Groups can't added as Guests.",
  /** Title for an existing guest */
  existingGuestTitle: 'Guest in Another Project',
  /** Details for an existing guest */
  existingGuestDetails: (label: string) =>
    `Guests can only access one project at a time. Adding ${label} here will remove them from their existing project.`,
  /** Informational text when adding a member */
  member: 'Members can be added to any project',
  /** Informational text when adding an existing member as guest */
  existingMemberDetails:
    "This user is already a paid Member and can't be added as a Guest.",
  /** Informational text for a group */
  group: 'Groups can be added to any Project',
  /** Invalid email error message */
  invalidEmail: 'Please enter a valid email address',
  /** Label for a new guest */
  newGuest: 'Add as new free Guest',
  /** Label for a new member */
  newMember: 'Add as new paid Member',
  /** Label for a new member with an Adobe account */
  newMemberAdobeAccount:
    'New members can only be added by an Adobe administrator.',
});

export const STATUS_TOOLTIP: Partial<
  Record<
    InputTokenStatus,
    (
      label?: string,
      memberCount?: number
    ) => {
      title: string;
      details?: string;
    }
  >
> = {
  [InputTokenStatus.NEW_GUEST]: () => ({
    title: TEXT.newGuest,
  }),
  [InputTokenStatus.EXISTING_GUEST]: (label) => ({
    title: TEXT.existingGuestTitle,
    details: TEXT.existingGuestDetails(label!) as string,
  }),
  [InputTokenStatus.EXISTING_GROUP]: (label, memberCount) => ({
    title: TEXT.existingGroupTitle(label!, memberCount!) as string,
    details: TEXT.existingGroupDetails as string,
  }),
  [InputTokenStatus.NEW_MEMBER]: () => ({
    title: TEXT.newMember,
  }),
  [InputTokenStatus.MEMBER]: () => ({
    title: TEXT.member,
  }),
  [InputTokenStatus.NEW_MEMBER_WARN]: () => ({
    title: TEXT.newMemberAdobeAccount,
  }),
  [InputTokenStatus.EXISTING_MEMBER]: () => ({
    title: '',
    details: TEXT.existingMemberDetails,
  }),
  [InputTokenStatus.GROUP]: () => ({
    title: TEXT.group,
  }),
  [InputTokenStatus.INVALID_EMAIL]: () => ({
    title: TEXT.invalidEmail,
  }),
};
